import { render, staticRenderFns } from "./cabinet-settings.vue?vue&type=template&id=07491e72&scoped=true"
import script from "./cabinet-settings.vue?vue&type=script&lang=js"
export * from "./cabinet-settings.vue?vue&type=script&lang=js"
import style0 from "./cabinet-settings.vue?vue&type=style&index=0&id=07491e72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07491e72",
  null
  
)

export default component.exports